import '@operato/help/ox-help-panel.js'
import '@operato/i18n/ox-i18n.js'
import './board/ox-property-editor-board-selector.js'
import './viewparts/menu-tools.js'

import { setupAppToolPart } from '@things-factory/apptool-ui/dist-client/index.js'
import { setupContextUIPart } from '@things-factory/context-ui/dist-client/index.js'

import { store, UPDATE_BASE_URL } from '@operato/shell'
import { registerDefaultGroups } from './board/component/register-default-groups.js'
import { appendViewpart, VIEWPART_POSITION } from '@operato/layout'

import { OxPropertyEditor } from '@operato/property-editor'
import { OxGristRendererJson5, registerEditor, registerRenderer } from '@operato/data-grist'
import { OxGristEditorHashtags } from '@operato/grist-editor/ox-grist-editor-hashtags.js'
import { OxGristRendererHashtags } from '@operato/grist-editor/ox-grist-renderer-hashtags.js'

import { BoardEditor } from './data-grist/board-editor.js'
import { BoardRenderer } from './data-grist/board-renderer.js'
import { ColorMapEditor } from './data-grist/color-map-editor.js'
import { ColorRangesEditor } from './data-grist/color-ranges-editor.js'

export default async function bootstrap() {
  registerRenderer('board', BoardRenderer)
  registerRenderer('color-map', OxGristRendererJson5)
  registerRenderer('color-ranges', OxGristRendererJson5)
  registerRenderer('hashtags', OxGristRendererHashtags)

  registerEditor('board', BoardEditor)
  registerEditor('color-map', ColorMapEditor)
  registerEditor('color-ranges', ColorRangesEditor)
  registerEditor('hashtags', OxGristEditorHashtags)

  OxPropertyEditor.register({
    'board-selector': 'ox-property-editor-board-selector'
  })

  /* append viewpart anchor to asidebar */
  appendViewpart({
    name: 'viewpart-info',
    viewpart: {
      show: false,
      hovering: 'edge',
      backdrop: true
    },
    position: VIEWPART_POSITION.ASIDEBAR
  })

  /* 
    set board-modeller group and default templates - should be called befor BoardModeller open 
  */
  registerDefaultGroups()

  await setupAppToolPart({
    toolbar: true,
    busybar: true,
    mdibar: false
  })

  await setupContextUIPart({
    titlebar: 'header',
    contextToolbar: 'page-footer'
  })

  store.dispatch({
    type: UPDATE_BASE_URL
  })
}
